export function identifyHotJarUser(userId: string | undefined) {
  if (typeof window !== 'undefined' && typeof window.hj === 'function' && userId) {
    try {
      window.hj('identify', userId, {})
    } catch(error) {
      console.warn('Failed to identify HotJar user:', error)
    }
  }
}

export function identifyHotJarUserByEmail(email: string | undefined) {
  if (typeof window !== 'undefined' && typeof window.hj === 'function' && email) {
    try {
      window.hj('identify', null, { email })
    } catch(error) {
      console.warn('Failed to identify HotJar user by email:', error)
    }
  }
}
